import { render, staticRenderFns } from "./TwModal.vue?vue&type=template&id=14fac164&"
import script from "./TwModal.vue?vue&type=script&lang=js&"
export * from "./TwModal.vue?vue&type=script&lang=js&"
import style0 from "./TwModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports